import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environment';

@Injectable({ providedIn: 'root' })
export class AlertInfoService {
  private http = inject(HttpClient);
  private env = inject(environment);

  public showAlertMessage() {
    return this.http.get<boolean>(
      `${this.env.etjansterCommonApiUrl}/alertmessage/show`,
    );
  }
}
